// ** Next Import
import { NavLink } from 'react-router-dom'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Icons
import CircleOutline from 'mdi-material-ui/CircleOutline'
import RecordCircleOutline from 'mdi-material-ui/RecordCircleOutline'

// ** Configs
import Logo from 'src/@core/components/logo'

// ** Import images
import BeemzLogoPng from "src/assets/images/beɘmz.png"
import BgImage from "src/assets/images/loginPageBgImg.png";
import { Stack } from '@mui/material'
import WelcomeIcon from 'src/@core/components/icons/WelcomeIcon'

// ** Styled Components
const MenuHeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // justifyContent: 'space-between',
  justifyContent: 'center',
  transition: 'padding .25s ease-in-out',
  minHeight: theme.mixins.toolbar.minHeight,
  marginBottom: 20,
}))

const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  lineHeight: 'normal',
  textTransform: 'uppercase',
  color: theme.palette.text.primary,
  transition: 'opacity .25s ease-in-out, margin .25s ease-in-out'
}))

const StyledLink = styled('div')({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  marginTop: 30
})

const VerticalNavHeader = props => {
  // ** Props
  const {
    hidden,
    navHover,
    settings,
    saveSettings,
    collapsedNavWidth,
    toggleNavVisibility,
    navigationBorderWidth,
    menuLockedIcon: userMenuLockedIcon,
    menuUnlockedIcon: userMenuUnlockedIcon,
    verticalNavMenuBranding: userVerticalNavMenuBranding
  } = props

  // ** Hooks & Vars
  const theme = useTheme()
  const { navCollapsed } = settings
  const menuCollapsedStyles = navCollapsed && !navHover ? { opacity: 0 } : { opacity: 1 }

  const menuHeaderPaddingLeft = () => {
    if (navCollapsed && !navHover) {
      if (userVerticalNavMenuBranding) {
        return 0
      } else {
        return (collapsedNavWidth - navigationBorderWidth - 30) / 8
      }
    } else {
      return 0
    }
  }

  return (
    <MenuHeaderWrapper className='nav-header' sx={{ pl: menuHeaderPaddingLeft() }}>
      {userVerticalNavMenuBranding ? (
        userVerticalNavMenuBranding(props)
      ) : (
        <NavLink to='/' style={{ textDecoration: 'none' }}>
          <StyledLink>
            <Stack direction={"row"} spacing={1}>
              <WelcomeIcon width={50} height={50} />
              <Box display={"flex"} flexDirection={"column"} justifyContent={"flex-start"}>
                <img src={BeemzLogoPng} alt='beemz_logo' style={{ height: "25px", width: "121px", objectFit: "contain" }} />
                <Typography sx={{ color: "#000000", fontWeight: 700, fontSize: "17px", marginLeft: "5px" }}>finance</Typography>
              </Box>
            </Stack>
          </StyledLink>
        </NavLink>
      )}
    </MenuHeaderWrapper>
  )
}

export default VerticalNavHeader
